const buildErrorMessage = ({
  err,
  prefixText,
}: {
  err: any;
  prefixText?: string;
}) => {
  let msg = prefixText || '';

  let errMsg = err.message;
  if (err.isAxiosError && err.response?.data?.message) {
    errMsg = err.response.data.message;
  }
  msg = msg ? `${msg}: ${errMsg}` : errMsg;
  return msg;
};
export { buildErrorMessage };
